import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';
import Accountant           from './Accountant';

let Quote = require('../../Managers/Quote.js');

class SelfEmployed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelfEmployedAccountantNeeded: false,
            isSelfEmployedTaxReturnsNeeded: false,
            isSelfEmployedUploadLaterModalVisible: false,
        };
        this.inputComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    handleSelfEmployedMethod(field, v) {
        this.setState({
            isSelfEmployedAccountantNeeded: false,
            isSelfEmployedTaxReturnsNeeded: false,
        });

        Quote.set('financialRefereeType', v, this.props.source);

        switch (v) {
            case 1:
                this.setState({ isSelfEmployedAccountantNeeded: true });
                break;
            case 5:
                this.setState({ isSelfEmployedTaxReturnsNeeded: true });
                break;
        }
    }

    /**
     * Callback to the parent that the employment is changing and we need to
     * show the next financial referee fields.
     *
     * @param v
     */
    handleEmploymentChanging(v) {
        if (this.props.callbackFunction) {
            this.props.callbackFunction(v);
        }
    }

    openUploadLaterModal() {
        this.setState({ isSelfEmployedUploadLaterModalVisible: true });
    }

    // Close all modals
    closeModals() {
        this.setState({
            isSelfEmployedUploadLaterModalVisible: false,
        });
    }

    getChildInputComponents() {
        let inputComponents = this.inputComponents;
        if (this.state.isSelfEmployedAccountantNeeded && this.accountant) {
            inputComponents = inputComponents.concat(this.accountant.getChildInputComponents());
        }
        inputComponents = inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });
        return inputComponents;
    }

    render() {
        let FaCross = require('react-icons/lib/fa/close');
        let index = this.props.financialRefereeStatus - 1;
        return(
            <div className="question-section">
                <question-row class="header-row">
                    <h2>Self-employed</h2>
                    <p>Please be advised, this is for UK-based self-employment only.</p>
                </question-row>

                {/* Xpress - only ask for net profit */}
                {this.props.productId === 11 ?
                    <Field
                        type="money"
                        fieldName={'salary' + index}
                        question="Net profit"
                        storageKey="applicantAnnualIncome"
                        dataValidation="2_decimal_money"
                        helpText="Profit should be relevant to this self-employment only."
                        source={this.props.source}
                        loadValues={true}
                        loadingKey={this.props.source + '.applicantAnnualIncome'}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                :
                    <div>
                        <Field
                            fieldName={'start_date' + index}
                            question="Date you started with your company"
                            storageKey="employmentStartDate"
                            type="date"
                            subType="full"
                            dataValidation="required_field"
                            source={this.props.source}
                            loadValues={true}
                            loadingKey={this.props.source + '.employmentStartDate'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            type="money"
                            fieldName={'salary' + index}
                            question="Net profit"
                            storageKey="applicantAnnualIncome"
                            dataValidation="2_decimal_money"
                            helpText="Profit should be relevant to this self-employment only."
                            source={this.props.source}
                            loadValues={true}
                            loadingKey={this.props.source + '.applicantAnnualIncome'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            question="Choose a method of providing details"
                            fieldName={'method' + index}
                            storageKey="financialRefereeType"
                            type="radio-group"
                            options={[
                                {
                                    value: 1,
                                    text: 'Accountant'
                                },
                                {
                                    value: 6,
                                    text: 'Not submitted first year tax return'
                                },
                                {
                                    value: 5,
                                    text: 'Self Assessment tax return'
                                },
                            ]}
                            callbackFunction={this.handleSelfEmployedMethod.bind(this)}
                            dataValidation="required_field"
                            source={this.props.source}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {this.state.isSelfEmployedAccountantNeeded ?
                            <Accountant
                                fieldPrefix={'selfEmployed' + index}
                                source={this.props.source}
                                ref={(instance) => {this.accountant = instance;}}
                            />
                        : null}

                        {this.state.isSelfEmployedTaxReturnsNeeded ?
                            <div>
                                <Field
                                    hasBorder={false}
                                    fieldName={'tax_return' + index}
                                    question="Upload tax return"
                                    storageKey="evidence"
                                    type="upload"
                                    contextInfo={'Self employed self assessment tax return evidence'}
                                    allowFileUploads={true}
                                    allowCameraUploads={true}
                                    labelExtra={'<p>Your Self Assessment tax return must have been completed and submitted to the inland revenue, partially completed tax returns will be rejected.</p><p>You can upload your evidence now below, or later upon completion of this form.</p>'}
                                    source={this.props.source}
                                />
                            </div>
                        : null}

                        {/* Don't ask if the employment is likely to change in the tenancy period if it's the third financial referee */}
                        {this.props.source !== 'BaseIndividualApplication.financialReferees.2' && this.props.source !== 'EmploymentFinancialReferee' ?
                            <Field
                                question={'Do you see this employment changing in the next ' + this.props.termLength + ' months?'}
                                fieldName={'changing' + index}
                                type="button-choice"
                                options={[
                                    {
                                        value: true,
                                        text: 'Yes'
                                    },
                                    {
                                        value: false,
                                        text: 'No'
                                    }
                                ]}
                                callbackFunction={this.handleEmploymentChanging.bind(this)}
                                ref={(instance) => { this.inputComponents.push(instance); }}
                            />
                        : null}

                        <div className={this.state.isSelfEmployedUploadLaterModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                            <div className="modal">
                                <div className="modal-header">
                                    Submit evidence later
                                    <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                        <FaCross className="pointer" />
                                    </div>
                                </div>
                                <div className="modal-body">
                                    <div className="content">
                                        <p>Content TBC</p>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <a onClick={this.closeModals.bind(this)} className="btn btn-default">Close</a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

SelfEmployed.propTypes = {
    productId:                  PropTypes.number.isRequired,
    termLength:                 PropTypes.number,
    source:                     PropTypes.string.isRequired,
    financialRefereeStatus:     PropTypes.oneOf([1, 2, 3]),
    callbackFunction:           PropTypes.func,
};

export default SelfEmployed;


// WEBPACK FOOTER //
// ./src/components/Screens/Sections/SelfEmployed.js